import {Injectable, inject} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EMPTY, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Revocation} from '../models/revocation.model';

@Injectable({providedIn: 'root'})
export class RevocationService {
  private http = inject(HttpClient);

  private loadedAll = false;
  private revocations: Revocation[] = [];

  getRevocations(): Observable<Revocation[]> {
    if (this.loadedAll) {
      return of(this.revocations);
    }
    const salt = new Date().getTime();
    return this.http.get<Revocation[]>('/webabo/revocations?' + salt).pipe(
      map(revocations => {
        this.loadedAll = true;
        this.revocations.push(...revocations);
        return this.revocations;
      }),
      catchError(error => {
        console.error('Fehler beim Laden der Widerrufe:', error);
        return EMPTY;
      })
    );
  }

  sendRevocation(data: unknown): Observable<unknown> {
    return this.http.post('/webabo/revocations', data, {headers: {'Content-Type': 'application/json'}}).pipe(
      map(() => {
        this.loadedAll = false;
      }),
      catchError(error => {
        console.error('Fehler beim Einreichen des Widerrufs:', error);
        throw error;
      })
    );
  }

  sendUnauthorizedRevocation(data: unknown): Observable<unknown> {
    return this.http.post('/webabo/revocations/unauthorized', data, {headers: {'Content-Type': 'application/json'}}).pipe(
      catchError(error => {
        console.error('Fehler beim Einreichen des unauthentifizierten Widerrufs:', error);
        throw error;
      })
    );
  }

  resetData(): void {
    this.loadedAll = false;
    this.revocations = [];
  }
}
